<template>
<b-container>
    <b-row class="justify-content-md-center">
        <b-col cols="12">
            <b-card no-body tag="h1" class="border-0 pt-3 pb-3 bg-transparent">{{pageTitle}}
            </b-card>
        </b-col>
    </b-row>
    <b-row v-if="recomandare_trimisa == true">

        <b-col cols="12">
            <b-card class="shadow mb-4 bg-white rounded bg-transparent">
                <b-card-title title-tag="h4">{{thankYouTitle}}</b-card-title>
                <b-card-text v-html="thankYouFirstLine"></b-card-text>
            </b-card>
            <b-button block squared size="md" v-on:click="recomanda">Recomandă încă o carte</b-button>
        </b-col>

    </b-row>
    <b-row class="justify-content-md-center" v-if="recomandare_trimisa == false">
        <b-card class="shadow mb-4 bg-white rounded bg-transparent">
            <b-card-text>
                Pentru a identifica mai ușor cartea vă recomandăm să completați măcar primele 3 câmpuri (titlu, autor, editură). De asemenea, puteți să completați o legătură web către o pagină în care se găsesc detalii despre carte. Vă mulțumim!
            </b-card-text>
        </b-card>
    </b-row>
    <div id="form" v-if="recomandare_trimisa == false" class="pb-5">

        <p v-if="errors.length">
            <b>Te rog completează:</b>
        </p>
        <p v-for="(error,index) in errors" :key="index">{{ error }}</p>

        <b-form @submit="onSubmit" @reset="onReset">
            <b-form-group id="input-group-1" label="Titlu:" label-for="input-1" description="">
                <b-form-input id="input-1" v-model="form.titlu" type="text" required placeholder="Titlu"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-2" label="Autor:" label-for="input-2" description="">
                <b-form-input id="input-2" v-model="form.autor" type="text"  required  placeholder="Autor"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-3" label="Anul publicării" label-for="input-3" description="">
                <b-form-input id="input-3" v-model="form.datapublicarii" type="text"  required  placeholder="Anul publicării"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-4" label="Editură:" label-for="input-4" description="">
                <b-form-input id="input-4" v-model="form.editura" type="text" placeholder="Editură"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-5" label="Legătură web:" label-for="input-5" description="">
                <b-form-input id="input-5" v-model="form.loculpublicarii" type="text" placeholder="Legătură web"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-6" label="ISBN:" label-for="input-6" description="">
                <b-form-input id="input-6" v-model="form.isbn" type="text" placeholder="Cod ISBN"></b-form-input>
            </b-form-group>

            <b-button type="submit" variant="primary" class="mr-2">Trimite recomandarea</b-button>
            <b-button type="reset" variant="danger" class="ml-2">Șterge</b-button>
        </b-form>
    </div>
</b-container>
</template>

<script>
export default {
    data() {
        return {
            pageTitle: 'Recomandă o carte',
            thankYouTitle: 'Recomandarea dvs. a fost trimisă.',
            thankYouFirstLine: '<p>Vă mulțumim că sunteți alături de noi.</p>',
            success: '',
            form: {
                titlu: null,
                autor: null,
                datapublicarii: null,
                editura: null,
                loculpublicarii: null,
                isbn: null
            },
            recomandare_trimisa: false,
            errors: [],
        }
    },
    watch: {
        titlu(value) {
            // binding this to the data value in the email input
            this.form.titlu = value;
       
               this.clearData();
            
            
        }
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault()
            
                fetch("https://app.bibliotecaarad.ro/backend/api/recomanda", {
                    method: "POST",
                    body: "titlu_carte=" + this.form.titlu + "&autor=" + this.form.autor + "&data_publicarii=" + this.form.datapublicarii + "&editura=" + this.form.editura + "&locul_publicarii=" + this.form.loculpublicarii + "&isbn=" + this.form.isbn,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                }).then((response) => {
                    if (response) {
                        this.recomandare_trimisa = true;
                    }
                });
            

        },
        clearData(){
         this.errors = [];
        },
        onReset(evt) {
            evt.preventDefault()
            this.form.titlu = ''
            this.form.autor = ''
            this.form.datapublicarii = ''
            this.form.editura = ''
            this.form.loculpublicarii = ''
            this.form.isbn = ''
        },
        recomanda: function (event) {
            if (event) {
                this.recomandare_trimisa = false;
            }
        },
    }
}
</script>
